<!--字段配置Ec-->
<template>
  <div class="field-main">
    <div class="field-menu">
      <span>{{originType}}-crm(数据接收方)</span>
      <span>招商智投(数据发送方)</span>
    </div>
    <el-collapse @change="handleChange">
      <el-collapse-item v-for="(item,index) in formFiled" :key="index" :title="item.groupName">
        <el-form label-width="120px" label-position="left" :model="formFiled" ref="formFiled">
          <el-form-item v-for="(v,i) in item.infoList" :label="v.className" :key="i">
            <el-select v-model="v.itemId" clearable placeholder="请选择项目名称">
              <el-option v-for="(k,j) in itemSelect" :key="j" :label="k.title" :value="k.id"></el-option>
            </el-select>
            <el-select v-model="v.channelId" clearable placeholder="请选择推广渠道">
              <el-option v-for="(k,j) in channelSelect" :key="j" :label="k.title" :value="k.id"></el-option>
            </el-select>
            <el-select v-model="v.resType" clearable placeholder="请选择资源来源类型">
              <el-option v-for="(k,j) in resTypeSelect" :key="j" :label="k.title" :value="k.id"></el-option>
            </el-select>
            <span v-if="v.className !== ''" class="arbtn" @click="addRow(index,i)">添加</span>
            <span v-else class="arbtn" @click="removeRow(index,i)">删除</span>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <div class="button">
      <el-button type="primary" size="small" @click="submitForm('formFiled')">保存</el-button>
      <el-button type="primary" :loading="loading" @click="updateForm()">更新数据</el-button>
    </div>
  </div>
</template>
<script>
  import Api from '@/api/client/ec-label-config'
  import {FIELD_CONDITION} from '@/models/ec-label-config'
  export default {
    props: {
      origin: {
        type: String
      }
    },
    data () {
      return {
        loading: false,
        formFiled: [],
        itemSelect: [],
        originType: '',
        channelSelect: [],
        resTypeSelect: [
          {
            id: 0,
            title: '不限'
          },
          {
            id: 1,
            title: '表单'
          },
          {
            id: 2,
            title: '智能聊天'
          }
        ]
      }
    },
    created () {
      if (this.origin === 'ec') {
        this.originType = 'ec'
      } else if (this.origin === 'lixiao') {
        this.originType = '励销'
      } else if (this.origin === 'xbb') {
        this.originType = '销帮帮'
      } else if (this.origin === 'huoban') {
        this.originType = '伙伴云'
      }
      this.getField()
      this.getItem()
      this.getChannels()
    },
    methods: {
      addRow (index, itemIndex) {
        const form = {
          channelId: null,
          classId: this.formFiled[index].infoList[itemIndex].classId,
          className: '',
          itemId: '',
          resType: ''
        }
        const list = this.formFiled[index].infoList
        list.splice(itemIndex + 1, 0, form)
      },
      removeRow (index, itemIndex) {
        this.$confirm('确定要删除吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.formFiled[index].infoList.splice(itemIndex, 1)
        }).catch(() => {})
      },
      getField () {
        const crmCode = {
          crmCode: this.origin
        }
        Api.getList(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            const data = body.list
            this.formFiled = data
          } else {
            this.$message.error(body.error)
          }
        })
      },
      updateForm () {
        const crmCode = {
          crmCode: this.origin
        }
        this.loading = true
        Api.UpdateList(crmCode, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.loading = false
            this.$message.success('保存成功！')
            const data = body.list
            this.formFiled = data
          } else {
            this.$message.error(body.error)
          }
        })
      },
      submitForm (formName) {
        const form = {
          crmCode: this.origin,
          list: this.formFiled
        }
        Api.saveList(form, response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.formFiled = body.list
            this.$message.success('保存成功！')
          } else {
            this.$message.error(body.error)
          }
        })
      },
      getItem () {
        Api.getItem(response => {
          let status = response.data.code
          let body = response.data.data
          if (status === '200') {
            let list = body
            const form = {
              id: 0,
              title: '不限'
            }
            list.unshift(form)
            this.itemSelect = list
          } else {
            this.$message.error(response.data.msg)
          }
        })
      },
      getChannels () {
        Api.getChannels(response => {
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            let list = body.list
            const form = {
              id: 0,
              title: '不限'
            }
            list.unshift(form)
            this.channelSelect = list
          } else {
            this.$message.error(body.error)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
.field-main .el-form-item__label{
  font-size: 14px;
  text-align: right!important;
  color:#888;
}
.field-main .el-collapse-item__header{
  padding-left:48px;
  color:#666;
  font-size: 16px;
  display: block;
  position: relative;
  height: 52px;
  line-height: 54px;
  i{
    position: absolute;
    left:180px;
    top:19px;
  }
}
.field-main .el-form-item__content{
  margin-left:320px!important;
}
.field-main .el-collapse-item__content{
  padding-bottom:10px;
}
.field-main .el-input__inner{
  width:180px;
  height: 36px;
  line-height: 36px;
}
.field-main .el-form-item{
  margin-bottom: 10px;
}
.default{
  margin-left:10px;
  .el-checkbox__label{
    padding-left:5px;
  }
}
</style>

<style scoped lang="scss">
.field-main{
  margin-top:5px;
  .default{
    margin-left:10px;
    .el-checkbox__label{
      padding-left:5px;
    }
  }
  .operation{
    color:#409EFF;
    padding-left:5px;
  }
  .field-menu{
    padding-bottom:15px;
    span{
      display: inline-block;
      font-size:16px;
      font-weight:600;
      color:#666;
      &:nth-child(1){
        margin-left:48px;
      }
      &:nth-child(2){
        margin-left:120px;
      }
    }
  }
  .el-input{
    width:50%;
  }
  .button{
    text-align: center;
    margin-top:60px;
    button{
      // width:100px;
      height:35px;
      line-height:1;
      background:rgba(8,94,204,1);
      border-radius:4px;
      padding: 0 30px;
      font-size: 14px;
      &.el-button--update{
        background:#fff!important;
        border:2px solid #C4C4C4;
        color:#737373;
      }
    }
  }
  .arbtn{
    margin-left:5px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/crm/EcLabelConfig.vue